import { apiPOST } from './api';

export const createSiteCoordinator = body => apiPOST('/site_coordinators', body);
